import Brace from "backbone.brace";
import Model from "../../models/chart-reviews/drg";

const Collection = Brace.Collection.extend({
  model: Model,
  save(options) {
    // POSTs collection to endpoint.
    // See http://backbonejs.org/#Sync

    // sync only when there are models in the collection
    if (this.length) {
      return Backbone.sync("create", this, options);
    }
  },
});

export { Collection as default };
